import { render, staticRenderFns } from "./TextEditorRenderer.vue?vue&type=template&id=13b8207c&scoped=true&"
import script from "./TextEditorRenderer.vue?vue&type=script&lang=js&"
export * from "./TextEditorRenderer.vue?vue&type=script&lang=js&"
import style0 from "./TextEditorRenderer.vue?vue&type=style&index=0&id=13b8207c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b8207c",
  null
  
)

export default component.exports